<app-download-app></app-download-app>

<app-login-form
                (onLogin)="onLogin($event)"
                [errorObj]="errorObj"
                [mobileNo]="mobileNo"
                [showContGuest]="showContGuest">
</app-login-form>
